import { TUTORIAL_HERO_LAYOUT } from '../constants/tutorialLayout.constants';

const { REF_WIDTH, MIN_SCALE, MAX_SCALE, HOOK_MASCOT, VS_AVATAR, CLIMB_MASCOT } =
  TUTORIAL_HERO_LAYOUT;

/**
 * Scale factor from usable width (accounts for slide horizontal padding), clamped so the
 * hero art never gets tiny on narrow phones or oversized on tablets/desktop web.
 */
export function getTutorialHeroScale(windowWidth: number): number {
  const usable = Math.max(0, windowWidth - 48);
  const raw = usable / REF_WIDTH;
  return Math.min(MAX_SCALE, Math.max(MIN_SCALE, raw));
}

/**
 * Hero element sizes for the current viewport width. Plain object (no StyleSheet) so the
 * helper stays testable without loading react-native in Vitest. Everything else in each
 * scene is laid out with flex/percentage styles.
 */
export function getTutorialHeroArtLayoutStyles(windowWidth: number) {
  const s = getTutorialHeroScale(windowWidth);
  return {
    scale: s,
    hookMascot: Math.round(HOOK_MASCOT * s),
    vsAvatar: Math.round(VS_AVATAR * s),
    climbMascot: Math.round(CLIMB_MASCOT * s),
  };
}

export type TutorialHeroArtLayout = ReturnType<typeof getTutorialHeroArtLayoutStyles>;
